import React from "react";
import { ColumnValueRendererProps, PhoneColumnValue } from "../table.data.interface";
import { Tooltip } from "@vibe/core";

const PhoneColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    (!columnData.text && isPreview) ||
    (!columnData?.value && otherBoardsValues)
  ) {
    return null;
  }

  const value = otherBoardsValues
    ? (columnData?.value as PhoneColumnValue)?.phone
    : isPreview
      ? columnData?.text
      : (columnData?.value as string);

  if (isPreview) {
    return (
      <div className="overflow-hidden whitespace-nowrap text-ellipsis">
        <Tooltip content={value}>
          <span>{value}</span>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      <a href={`tel:${value}`} className="no-underline cursor-pointer hover:underline">
        {value as string}
      </a>
    </div>
  );
};

export default PhoneColumn;
